import { Filters } from "./filters";
import { Summary } from "./summary";
import { Columns } from "./columns";
import { ReportConfigBase } from "../index";
import { EReportTypes } from "../../routes/report_types";

const FinanceDepositInvoicesReportConfig: ReportConfigBase = {
  type: EReportTypes.FinanceDepositInvoices,
  endpoint: "report/finance-deposit-invoices",
  filtersBase: Filters,
  summaryBase: Summary,
  columnsBase: Columns,
  withSelection: false,
  intro: {
    description:
      "Deposit Invoices",
    url: "https://help.commonsku.com/knowledge/new-client-invoicing-report",
  },
};

export default FinanceDepositInvoicesReportConfig;
